// src/components/useSound.js
import { useCallback } from 'react';

const useSound = () => {
 const playHover = useCallback(() => {
   try {
     const audioContext = new (window.AudioContext || window.webkitAudioContext)();
     const oscillator = audioContext.createOscillator();
     const gainNode = audioContext.createGain();

     oscillator.connect(gainNode);
     gainNode.connect(audioContext.destination);

     gainNode.gain.value = 0.05;
     oscillator.frequency.value = 2000;
     oscillator.type = 'sine';

     oscillator.start();
     oscillator.stop(audioContext.currentTime + 0.05);
   } catch (error) {
     console.log('Audio playback failed');
   }
 }, []);

 const playClick = useCallback(() => {
   try {
     const audioContext = new (window.AudioContext || window.webkitAudioContext)();
     const oscillator = audioContext.createOscillator();
     const gainNode = audioContext.createGain();

     oscillator.connect(gainNode);
     gainNode.connect(audioContext.destination);

     gainNode.gain.value = 0.1;
     oscillator.frequency.value = 1000;
     oscillator.type = 'sine';

     oscillator.start();
     oscillator.stop(audioContext.currentTime + 0.1);
   } catch (error) {
     console.log('Audio playback failed');
   }
 }, []);

 return { playHover, playClick };
};

export default useSound;